export const COMMENTS_HEADER = "Event Log";
export const ADD_COMMENT_BUTTON_TEXT = "Add Comment";
export const NO_COMMENTS_TEXT = "No comments yet.";

export const ADD_COMMENT_MODAL_TEST_ID = "add-comment-modal";
